import axios from "axios";
import { toast } from "react-toastify";
import { store } from "./stor"; // اطمینان حاصل کنید که مسیر "./stor" درست است
import { setAccessToken, clearAccessToken } from "./../AuthProvider"; // اطمینان حاصل کنید که مسیر "./../AuthProvider" درست است

const axiosInstance = axios.create({
  baseURL: "https://api.pendartarharia.com/api/v1",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// [جدید] تابع رفرش توکن استخراج و export شد
export const forceRefreshToken = async () => {
  if (isRefreshing) {
    console.log("Waiting for existing token refresh...");
    return new Promise(function(resolve, reject) {
      failedQueue.push({ resolve, reject });
    })
    .then(token => token)
    .catch(err => Promise.reject(err));
  }

  console.log("Starting new token refresh...");
  isRefreshing = true;

  try {
    // [نکته] اینجا از axios خام استفاده شده تا وارد لوپ interceptor نشود
    const { data } = await axios.post(
      "https://api.pendartarharia.com/api/v1/auth/refresh-token",
      {},
      { withCredentials: true }
    );
    const newAccessToken = data.data.token;
    console.log("Token refreshed successfully.");
    store.dispatch(setAccessToken(newAccessToken));
    processQueue(null, newAccessToken);
    return newAccessToken;
  } catch (refreshError) {
    console.error("Failed to refresh token:", refreshError);
    toast.error("مدت زمان ورود شما تمام شده، لطفاً دوباره لاگین کنید.");
    store.dispatch(clearAccessToken());
    processQueue(refreshError, null);
    return Promise.reject(refreshError);
  } finally {
    isRefreshing = false;
  }
};


// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState().auth;
    if (state.accessToken) {
      config.headers.Authorization = `Bearer ${state.accessToken}`;
    }
    return config;
  },
  (error) => {
    toast.error("مشکلی در تنظیمات درخواست پیش آمده!");
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.data?.token) {
      store.dispatch(setAccessToken(response.data.data.token));
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const authState = store.getState().auth;

    // منطق رفرش توکن برای خطای 401
    if (error.response?.status === 401 && !originalRequest._retry && authState.isAuthenticated) {
      originalRequest._retry = true;
      
      console.log("Axios 401 Interceptor: Triggering token refresh...");
      // [تغییر] استفاده از تابع استخراج شده
      try {
        const newAccessToken = await forceRefreshToken(); 
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    // ⭐ نقطه کلیدی تغییر اینجاست ⭐
    // اگر کاربر خواسته باشد خطا را به صورت دستی مدیریت کند، آن را برمی‌گردانیم
    if (originalRequest?._errorMe) {
      return Promise.reject(error);
    }


    return handleErrors(error);
  }
);

const handleErrors = (error) => {

  if (!error.response) {
    toast.error("ارتباط با سرور ممکن نیست. لطفاً اینترنت خود را بررسی کنید.", {
      position: "top-center",
    });
 
    return Promise.reject(error);
  }

  const response = error.response;
  switch (response.status) {
    case 400: // Bad Request
      if (response.data.title) {
        toast.error(response.data.title, { position: "top-center" });
      } else if (response.data.errors && response.data.errors.length > 0) {
        toast.error(response.data.errors[0].message || "درخواست شما مشکل دارد.", {
          position: "top-center",
        });
      } else {
        toast.error("درخواست شما مشکل دارد.", { position: "top-center" });
      }
      break;
    // ... بقیه case ها
    case 401:
    // [نکته] این خطا فقط زمانی نشان داده می‌شود که رفرش توکن *شکست خورده* باشد
      toast.warn("دسترسی غیرمجاز. لطفاً وارد شوید.", { position: "top-center" });
      break;
    case 403:
      toast.error("شما اجازه دسترسی به این بخش را ندارید.", { position: "top-center" });
      break;
    case 404:
      toast.info(
        (response.data?.errors?.[0]?.message) || "محتوای درخواست شده موجود نیست!",
        { position: "top-center" }
      );
      break;
    case 500:
      toast.error("خطای سرور. لطفاً دوباره تلاش کنید.", { position: "top-center" });
      break;
    default:
      toast.error(
        response.data?.message ||
        response.data?.errors?.[0]?.message ||
        "خطای سیستمی رخ داده است.",
        { position: "top-center" }
      );
      break;
  }
  // در انتهای handleErrors هم خطا را reject کنید
  return Promise.reject(error);
};

export default axiosInstance;

